"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHttpConflict = exports.isHttpNotFound = exports.isHttpBadRequest = exports.isHttpSuccess = void 0;
function isHttpSuccess(status) {
    return Math.floor(status / 100) === 2;
}
exports.isHttpSuccess = isHttpSuccess;
function isHttpBadRequest(status) {
    return status === 400;
}
exports.isHttpBadRequest = isHttpBadRequest;
function isHttpNotFound(status) {
    return status === 404;
}
exports.isHttpNotFound = isHttpNotFound;
function isHttpConflict(status) {
    return status === 409;
}
exports.isHttpConflict = isHttpConflict;
//# sourceMappingURL=status.js.map